import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import Dialog from "material-ui/Dialog";
import Toolbar from "material-ui/Toolbar";
import IconButton from "material-ui/IconButton";
import Typography from "material-ui/Typography";
import CloseIcon from "material-ui-icons/Close";

const styles = theme => ({
  root: {
    background: theme.palette.background.paper,
    paddingBottom: 24
  },
  paper: {
    margin: "auto",
    maxWidth: 600
  },
  appBar: {
    height: 64,
    backgroundColor: theme.palette.primary.main
  },
  title: {
    flex: 1,
    color: theme.palette.background.appBar
  },
  inner: {
    margin: "64px 32px 0",
    height: "100%",
    minWidth: 280
  },
  closeIcon: {
    marginRight: 60
  }
});

const ModalFormDialog = props => {
  const { classes, open, onSave, onCancel, title, children } = props;

  const closeButton = (
    <IconButton
      key={1}
      className={classes.closeIcon}
      color="contrast"
      onClick={onCancel}
      aria-label="Close"
    >
      <CloseIcon />
    </IconButton>
  );

  const titleElement = (
    <Typography
      key={2}
      noWrap
      type="title"
      align="center"
      className={classes.title}
    >
      {title}
    </Typography>
  );

  const saveButton = (
    <Button key={3} color="contrast" onClick={onSave}>
      save
    </Button>
  );

  const appBar = (
    <div className={classes.appBar}>
      <Toolbar>{[closeButton, titleElement, saveButton]}</Toolbar>
    </div>
  );

  return (
    <div>
      <Dialog
        fullScreen
        classes={{
          root: classes.root,
          paper: classes.paper
        }}
        open={open}
        onRequestClose={onCancel}
      >
        {appBar}
        <div className={classes.inner}>{children}</div>
      </Dialog>
    </div>
  );
};

ModalFormDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export { ModalFormDialog };

export default withStyles(styles, { name: "ModalFormDialog" })(ModalFormDialog);



// WEBPACK FOOTER //
// ./src/ModalFormDialog.js